export default "__VITE_ASSET__VfL4kS17__"